var map = {
	"./1-kilo-blue.svg": "d6ec",
	"./1-kilo-pink.svg": "2b44",
	"./2-kilo-blue.svg": "568d",
	"./2-kilo-pink.svg": "700c",
	"./arrow-down-blue.svg": "24f7",
	"./arrow-down-pink.svg": "bbbf",
	"./arrow-up-pink.svg": "2c9b",
	"./baby-blue.svg": "7328",
	"./baby-pink.svg": "3871",
	"./back-blue.svg": "cc69",
	"./back-pink.svg": "879f",
	"./balloon-blue.svg": "5ad6",
	"./balloon-pink.svg": "5334",
	"./bandaid-blue.svg": "3e04",
	"./bandaid-pink.svg": "6399",
	"./bear-blue.svg": "a01d",
	"./bear-pink.svg": "662e",
	"./bell-filled.svg": "0e16",
	"./bell-lighter.svg": "077d",
	"./big-bottle-blue.svg": "9096",
	"./big-bottle-pink.svg": "642b",
	"./book-blue.svg": "07c2",
	"./book-lighter.svg": "58b6",
	"./book-pink.svg": "0bc8",
	"./bottle-blue.svg": "5be5",
	"./bottle-pink.svg": "8b87",
	"./butterfly-blue.svg": "40b4",
	"./butterfly-pink.svg": "55a1",
	"./camera-blue.svg": "669b",
	"./camera-pink.svg": "bcef",
	"./camera-white.svg": "d62f",
	"./check-blue.svg": "64ef",
	"./check-pink.svg": "ce11",
	"./check-white.svg": "5131",
	"./clock-blue.svg": "2ad6",
	"./clock-pink.svg": "c1c8",
	"./close-blue.svg": "cf11",
	"./close-pink.svg": "65cf",
	"./comment-blue.svg": "90ce",
	"./comment-filled.svg": "ad77",
	"./comment-lighter.svg": "f2fc",
	"./crib-blue.svg": "5a21",
	"./crib-pink.svg": "093d",
	"./drip-feed-blue.svg": "bbc2",
	"./drip-feed-pink.svg": "8517",
	"./duck-blue.svg": "9dc1",
	"./duck-pink.svg": "3122",
	"./eye-blue.svg": "aef5",
	"./eye-pink.svg": "d50b",
	"./flag-blue.svg": "f5d8",
	"./flag-pink.svg": "ee33",
	"./globe-grey.svg": "fd98",
	"./globe-lines-grey.svg": "75b3",
	"./graph-blue.svg": "2a1f",
	"./graph-pink.svg": "f142",
	"./heart-blue.svg": "5f3f",
	"./heart-filled.svg": "2025",
	"./heart-lighter.svg": "392c",
	"./heart-pink.svg": "4fd3",
	"./home-blue.svg": "2de3",
	"./home-filled.svg": "7004",
	"./home-lighter.svg": "2569",
	"./home-pink.svg": "abce",
	"./iconlist": "91a3",
	"./iconlist.js": "91a3",
	"./kilo-blue.svg": "8b3a",
	"./kilo-pink.svg": "076f",
	"./kiss-blue.svg": "467a",
	"./kiss-pink.svg": "ddc2",
	"./lock-grey.svg": "a7d1",
	"./menu-filled.svg": "9fac",
	"./menu-grey.svg": "90ee",
	"./menu-lighter.svg": "8c7f",
	"./moustache-blue.svg": "e3aa",
	"./moustache-pink.svg": "a34e",
	"./multiple-babies-pink.svg": "2c75",
	"./multiple-babies.svg": "1339",
	"./pen-blue.svg": "5355",
	"./pen-pink.svg": "cd9c",
	"./phone-blue.svg": "fa20",
	"./phone-pink.svg": "321f",
	"./phone-white.svg": "8e47",
	"./plus-blue.svg": "cc0d",
	"./plus-pink.svg": "c44e",
	"./plus-white.svg": "7e53",
	"./question-mark-blue.svg": "abf1",
	"./question-mark-pink.svg": "257c",
	"./right-to-bracket-solid-blue.svg": "622b",
	"./ruler-blue.svg": "9a07",
	"./ruler-pink.svg": "6608",
	"./search-blue.svg": "9ac9",
	"./search-pink.svg": "bf89",
	"./settings-blue.svg": "4325",
	"./settings-pink.svg": "5d6c",
	"./share-blue.svg": "d901",
	"./share-pink.svg": "0224",
	"./sign-out-blue.svg": "87af",
	"./sign-out-pink.svg": "785af",
	"./sleep-blue.svg": "2d66",
	"./sleep-pink.svg": "9b3c",
	"./star-filled.svg": "3d1d",
	"./tag-pink.svg": "fd71",
	"./translate.svg": "fac3",
	"./trophy-blue.svg": "10c3",
	"./trophy-pink.svg": "14ec",
	"./truck-blue.svg": "14a5",
	"./truck-pink.svg": "ac0d",
	"./visit-filled.svg": "40e1",
	"./visit-lighter.svg": "14d0",
	"./webcam-filled.svg": "8306",
	"./webcam-lighter.svg": "2c8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";